// Določi API URL glede na okolje
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3001/api'  // Razvoj
  : '/api';                      // Produkcija

// Shranjevanje thread ID-ja v localStorage
const saveThreadId = (threadId) => {
  localStorage.setItem('threadId', threadId);
};

// Ustvarjanje praznega threada
export const createEmptyThread = async () => {
  try {
    const response = await fetch(`${API_URL}/thread/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`Failed to create empty thread: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    saveThreadId(data.threadId);
    return data.threadId;
  } catch (error) {
    console.error('Error creating empty thread:', error);
    throw error;
  }
};

// Ustvarjanje novega thread-a in prvi zagon
export const createNewThread = async (message, onChunkReceived) => {
  try {
    const response = await fetch(`${API_URL}/thread-and-run`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ message }),
      credentials: 'include',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`Failed to create thread: ${response.status} ${response.statusText}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { value, done } = await reader.read();
      
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.trim() === '') continue;
        
        if (line.startsWith('data: ')) {
          const data = line.slice(6);
          
          if (data === '[DONE]') {
            return;
          }

          try {
            const parsedData = JSON.parse(data);
            if (parsedData.type === 'thread_id') {
              saveThreadId(parsedData.threadId);
            }
            onChunkReceived(parsedData);
          } catch (e) {
            console.error('Error parsing SSE data:', e);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error creating thread:', error);
    throw error;
  }
};

// Pridobivanje zgodovine sporočil
export const fetchThreadMessages = async (threadId) => {
  try {
    const response = await fetch(`${API_URL}/messages/${threadId}`, {
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch messages: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data.messages;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

// Pošiljanje sporočila in pridobivanje odgovora
export const fetchAssistantResponseStream = async (message, threadId, onChunkReceived) => {
  try {
    const response = await fetch(`${API_URL}/message/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        threadId,
        message
      }),
      credentials: 'include',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`Failed to send message: ${response.status} ${response.statusText}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let accumulatedContent = '';

    while (true) {
      const { value, done } = await reader.read();
      
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.trim() === '') continue;
        
        if (line.startsWith('data: ')) {
          const data = line.slice(6);
          
          if (data === '[DONE]') {
            onChunkReceived({
              status: 'completed',
              content: accumulatedContent
            });
            return;
          }

          try {
            const parsedData = JSON.parse(data);
            if (parsedData.type === 'content') {
              accumulatedContent += parsedData.content;
              onChunkReceived({
                status: 'streaming',
                content: accumulatedContent
              });
            }
          } catch (e) {
            console.error('Error parsing SSE data:', e);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error in streaming response:', error);
    throw error;
  }
}; 